import type {TypedSchema} from 'schemaDefinition/types';
import type {NorafUpdatesIgnoreListItem} from 'services/agent/types';

export const agentNorafUpdateIgnorelistSchema: TypedSchema<NorafUpdatesIgnoreListItem> =
  {
    name: 'norafUpdateIgnorelist',
    key: 'norafUpdateIgnorelist',
    parts: [
      {
        type: 'text',
        name: 'id',
      },
      {
        type: 'text',
        name: 'nationalId',
      },
      {
        type: 'text',
        name: 'name',
      },
      {
        type: 'text',
        name: 'agentId',
      },
    ],
  };
